var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5,6.4c-.2-1-1-1.7-1.9-2-1.7-.4-8.6-.4-8.6-.4,0,0-6.9,0-8.6.5-1,.3-1.7,1-1.9,2-.4,1.7-.5,3.5-.5,5.3s.1,3.6.5,5.3c.3.9,1,1.7,1.9,1.9,1.7.5,8.6.5,8.6.5,0,0,6.9,0,8.6-.5,1-.3,1.7-1,1.9-2,.3-1.7.5-3.5.5-5.2,0-1.8-.1-3.6-.5-5.4ZM9.8,15v-6.5l5.8,3.3-5.8,3.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1e572c1f0c01e87026fd6bd8b8fe922c.svg";
export { ForwardRef as ReactComponent };